__turbopack_context__.v({
  "layoutPlug": "BaseLayout-module-scss-module__PtMmnG__layoutPlug",
});
